import React from 'react'

import { Button } from '@/components/ui/button'
import { useEmailClient } from '@/hooks/useEmailClient'
import { cn } from '@/lib/utils'

interface Props {
  children: React.ReactNode
  className?: string
  variant?: React.ComponentProps<typeof Button>['variant']
}

const ContactUsButton: React.FC<Props> = ({
  children,
  className,
  variant = 'plain',
}) => {
  const emailClient = useEmailClient()

  return (
    <Button
      onClick={emailClient.open}
      variant={variant}
      className={cn(className, variant === 'plain' ? 'text-primary' : '')}
    >
      {children}
    </Button>
  )
}

export default ContactUsButton
